module.exports = __webpack_public_path__ + "img/infc_diabfcs.73171289.png";